import AModalConfirmation from './a-modal-confirmation.vue'

export default AModalConfirmation
